import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { END_BUTTONS_STYLE } from "@client/content/controls/Form/lib";
import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton, ModuleSecondaryButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { FormField } from "@client/controls/Form/Field/component";
import TextArea from "@client/controls/Inputs/TextArea/component";
import { EMPTY_OBJECT } from "@client/lib/misc";
import ButtonsContainer from "@common/controls/Container/Buttons";
import { type FormControlledRenderParams } from "@common/controls/Form/component";
import { FormModalControlled } from "@common/controls/Modal/Modals/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { isDummyOrder } from "../../lib";

export type ModalData = { comment: string };

export type MapProps = RootContainerProps & {
  error: string | null;
  orderId: string;
  isDetail: boolean;
  isVisible: boolean;
};

export type ActionProps = {
  onClose: () => void;
  onSubmit: (data: ModalData) => void;
};

export type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  return (
    <FormModalControlled
      submit={props.onSubmit}
      title={i18n.addComment}
      isVisible={props.isVisible}
      defaultValues={EMPTY_OBJECT}
      width="400px"
      errorMessage={props.error}
      onClose={props.onClose}
    >
      {({ values, submit }: FormControlledRenderParams<ModalData>) => (
        <FormStyleProvider {...getEntityRef(props)}>
          <FormField
            label={i18n.comment}
            Component={TextArea}
            componentProps={{
              rows: 5,
              placeholder: i18n.orderCommentPlaceholder
            }}
            isRequired
            name="comment"
            value={values.comment}
          />

          <ButtonsContainer style={END_BUTTONS_STYLE}>
            <ModuleSecondaryButton {...getRootContainerProps(props)} onClick={props.onClose} caption={i18n.cancel} />
            <ModuleButton
              {...getRootContainerProps(props)}
              isDisabled={isDummyOrder(props.orderId)}
              onClick={submit}
              caption={i18n.submit}
              style={{ margin: 0 }}
            />
          </ButtonsContainer>
        </FormStyleProvider>
      )}
    </FormModalControlled>
  );
};
